<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import TutorBillingRecordChips from '../TutorBillingRecordChips.vue'
import { useModalTutorBillingBulkErase } from '../../model/modal-tutor-billing-bulk-erase.hook'

defineOptions({
  name: 'ModalTutorBillingBulkErase',
})

const {
  isOpen,
  isSaving,
  chips,
  isOverLimit,
  isValid,
  setClose,
  setErase,
} = useModalTutorBillingBulkErase()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    title="Are you sure you want to erase billing info for selected tutors?"
    class-name="modal-tutor-billing-bulk-erase"
    is-close-button
    @click:overlay="setClose"
    @click:close="setClose"
  >
    <TutorBillingRecordChips :chips="chips" />

    <AppText
      v-if="isOverLimit"
      name="body2"
      color="red-500"
      class="modal-tutor-billing-bulk-erase__hint"
    >
      Select up to 100 records
    </AppText>

    <template #controls>
      <BtnPrimary
        text="Erase billing info"
        color="red"
        :disabled="!isValid || isSaving"
        @click="setErase"
      />
      <BtnSecondary
        text="Keep it"
        :disabled="isSaving"
        @click="setClose"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalTutorBillingBulkErase.scss" />
